import React, { useState, useEffect, useMemo } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import ReactSlider from 'react-slider';
import classnames from 'classnames';

import { Button, ButtonGroup } from 'reactstrap';
import FundSelector from "./components/FundSelector";
import ResultsTable from "./components/ResultsTable";

import DisclosuresHTML from "./components/DisclosuresHTML"

import axios from 'axios';

import Modal from 'react-bootstrap/Modal'

import Header from "./components/Header"
import Footer from "./components/Footer"
import { tealiumTrack } from './utils/tealium';


export default function App(props) {




	const API_URL = '/api/getPyramidResponse';
	const arrFunds = {
		"BMSIX": { label: 'BMSIX: BlackRock  Income Fund', value: 'BMSIX'},
		"BSIIX": { label: 'BSIIX: BlackRock Strategic Income Opportunities Fund', value: 'BSIIX'},
		"IUSB": { label: 'IUSB: iShares Core Total USD Bond Market ETF', value: 'IUSB'},
		"MAYHX": { label: 'MAYHX: BlackRock High Yield Municipal Fund', value: 'MAYHX'},
		"MAMTX": { label: 'MAMTX: BlackRock Strategic Municipal OpportunitiesFund', value: 'MAMTX'},
		"MUB": { label: 'MUB: iShares National Municipal Bond ETF', value: 'MUB'},
		"ISTB": { label: 'ISTB: iShares Core 1-5 Year USD Bond ETF', value: 'ISTB'},
		"MAHQX": { label: 'MAHQX: BlackRock Total Return Fund', value: 'MAHQX'},
		"SUB": { label: 'SUB: iShares Short-Term National Municipal Bond ETF', value: 'SUB'},
		"MANLX": { label: 'MANLX: BlackRock National Municipal Fund', value: 'MANLX'},
		"AGG": { label: 'AGG: iShares Core U.S. Aggregate Bond ETF', value: 'AGG'},
		"BHYIX": { label: 'BHYIX: BlackRock High Yield Bond Fund', value: 'BHYIX'},
		"BFMSX": { label: 'BFMSX: BlackRock Low Duration Bond Fund', value: 'BFMSX'},

		"BFMCX": { label: 'BFMCX: BlackRock Core Bond Fund', value: 'BFMCX'},
		"USHY": { label: 'USHY: iShares Broad USD High Yield Corporate Bond ETF', value: 'USHY'},
		"N/A": { label: 'N/A', value: 'N/A'}
	}


	const uploadedFileLink='favicon.ico';

	const [sliderValue, setSliderValue] = useState(0);

	const [allocation, setAllocation] = useState('C');
	const [taxMuniciple, setTaxMuniciple] = useState('tax');

	const [incomeValue, setIncomeValue] = useState(arrFunds['BMSIX']);
	const [incomeAllocation, setIncomeAllocation] = useState(30);
	const [incomeOptions, setIncomeOptions] = useState([]);
	const [incomeWidth, setIncomeWdith] = useState(0);

	const [capitalValue, setCapitalValue] = useState(arrFunds['BSIIX']);
	const [capitalAllocation, setCapitalAllocation] = useState(30);
	const [capitalOptions, setCapitalOptions] = useState([]);
	const [capitalWidth, setCapitalWidth] = useState(0);

	const [equityValue, setEquityValue] = useState(arrFunds['IUSB']);
	const [equityAllocation, setEquityAllocation] = useState(40);
	const [equityOptions, setEquityOptions] = useState([]);
	const [equityWidth, setEquityWidth] = useState(0);

	let modDateFormat = '11/30/2025 BlackRock';
	let modDateFormatTwo = "November 30, 2025 BlackRock";

	const [resultsData, setResultsData] = useState({});

		// Internet Explorer 6-11
		const isIE = /*@cc_on!@*/false || !!document.documentMode;

		const stats = useMemo(() => {
			const segments = [
				incomeValue && incomeValue.value !== 'N/A' ? `${incomeValue.value}|${incomeAllocation || 0}` : null,
				capitalValue && capitalValue.value !== 'N/A' ? `${capitalValue.value}|${capitalAllocation || 0}` : null,
				equityValue && equityValue.value !== 'N/A' ? `${equityValue.value}|${equityAllocation || 0}` : null
			].filter(Boolean); // Remove null values
		
			return {
				uri360: segments.join(':')
			};
		}, [incomeValue, capitalValue, equityValue, incomeAllocation, capitalAllocation, equityAllocation]);
		
	
	useEffect(() => {
	
			tealiumTrack('bond-pyramid:tab-selected:get-started','view')
	
	},[])


	// Used to build the bars (pink yellow orange)
	const totalBarWidth = 90
	useEffect(() => {
		// get the max value

			console.log('e'+equityAllocation)
			console.log('i'+incomeAllocation)
			console.log('c'+capitalAllocation)


		let max = Math.max(incomeAllocation,capitalAllocation,equityAllocation)

		//The highest value will get 90% (totalBarWidth) of the div, the other values will get percentage
		if (incomeAllocation === 100) {
			setIncomeWdith(totalBarWidth)
		} else if (incomeAllocation === 0 || incomeAllocation === 10) {
			setIncomeWdith(25)
		} else {
			setIncomeWdith(incomeAllocation)
		}

		if (capitalAllocation === 100) {
			setCapitalWidth(totalBarWidth)
		} else {
			setCapitalWidth(capitalAllocation)
		}

			console.log('eq')
			console.log(equityAllocation)
		if (equityAllocation === 100) {
			setEquityWidth(totalBarWidth)
		} else {
			setEquityWidth(equityAllocation)
		}
	},[incomeAllocation,capitalAllocation,equityAllocation])

	useEffect(() => {
		
		//taxMuniciple
		
		if (allocation === 'C') {
			setIncomeAllocation(30)
			setCapitalAllocation(30)
			setEquityAllocation(40)

			if (taxMuniciple === 'tax') {
				setIncomeValue(arrFunds['BMSIX'])
				setIncomeOptions(['BMSIX','BHYIX','USHY'])
				setCapitalValue(arrFunds['BSIIX'])
				setCapitalOptions(['BSIIX','BFMSX','ISTB'])
				setEquityValue(arrFunds['IUSB'])
				setEquityOptions(['IUSB','MAHQX','AGG'])
			} else {
				setIncomeValue(arrFunds['MAYHX'])
				setIncomeOptions(['MAYHX'])
				setCapitalValue(arrFunds['MAMTX'])
				setCapitalOptions(['MAMTX'])
				setEquityValue(arrFunds['MUB'])
				setEquityOptions(['MUB'])
			}
		} else if (allocation === 'M') {
			setIncomeAllocation(10)
			setCapitalAllocation(40)
			setEquityAllocation(50)

			if (taxMuniciple === 'tax') {
				setIncomeValue(arrFunds['BMSIX'])
				setIncomeOptions(['BMSIX','BHYIX','USHY'])
				setCapitalValue(arrFunds['ISTB'])
				setCapitalOptions(['ISTB','BSIIX'])
				setEquityValue(arrFunds['MAHQX'])
				setEquityOptions(['MAHQX','BFMCX','IUSB','AGG'])
			} else {
				setIncomeValue(arrFunds['MAYHX'])
				setIncomeOptions(['MAYHX'])
				setCapitalValue(arrFunds['SUB'])
				setCapitalOptions(['SUB'])
				setEquityValue(arrFunds['MANLX'])
				setEquityOptions(['MANLX'])
			}
		} else if (allocation === 'A') {
			setIncomeAllocation(0)
			setCapitalAllocation(30)
			setEquityAllocation(70)

			setIncomeValue(arrFunds['N/A'])
			setIncomeOptions(['N/A'])

			if (taxMuniciple === 'tax') {
				setCapitalValue(arrFunds['BSIIX'])
				setCapitalOptions(['BSIIX','BFMSX','ISTB'])
				setEquityValue(arrFunds['AGG'])
				setEquityOptions(['AGG','MAHQX','IUSB'])
			} else {
				setCapitalValue(arrFunds['MAMTX'])
				setCapitalOptions(['MAMTX'])
				setEquityValue(arrFunds['MANLX'])
				// todo: this one is different and needs split, will need to special case somehow.
				setEquityOptions(['MANLX','MUB'])
			}
		}

	},[allocation,taxMuniciple])

	useEffect(() => {
		fetchData()
	},[incomeValue,capitalValue,equityValue])

	const fncBuildPayload = () => {
		return {
			incomeValue: incomeValue.value,
			incomeAllocation: incomeAllocation,
			capitalValue: capitalValue.value,
			capitalAllocation: capitalAllocation,
			equityValue: equityValue.value,
			equityAllocation: equityAllocation
		}
	}

	const fetchData = () => {
		setResultsData({})
		return new Promise((resolve, reject) => {
				axios.post(
					API_URL,
					fncBuildPayload()
				).then((results) => {
					setResultsData(results.data)
					resolve()
				}).catch((err) => {
					reject()
				})
		})
	};


	let tealiumLink = (href,title,cls,cls2) => {

	

		return (
			
				<a href="#" onClick={(e) => fncOpenHref(href,title)}>
		
				<button className={cls2}>{title} <i className={cls} /></button>
			
				</a>

		)
	}

	let tealiumLinkFooter = (href,title) => {

	

		return (
			
				<a href="#" className="moreinfo" onClick={(e) => fncOpenHref(href,title)}>{title}</a>

		)
	}	


	let fncOpenHref = (href,title) => {
	
		tealiumTrack('bond-pyramid:link:'+title,'link')

	   if (isIE) {
			const newWindowIEH = window.open(href, '_blank', 'width=1200,height=800,scrollbars=1,location=no,menubar=no,toolbar=no,resizable=yes,status=yes').focus();
	   } else {
			const newWindowH = window.open(href, '_blank', 'noopener,noreferrer');
	   }



	}

	const [methodologyModal, setMethodologyModal] = useState(false);

	// if the modal is open, let tealium know about it. 
useEffect(() => {
	if (methodologyModal) tealiumTrack('core-etfs:link:view methodology')
},[methodologyModal])

	return (
		<div className="app app-l" >
				<Header />
			<div className="container"> 
				<section className="row header-section">
					<div className="col-12">
						<h3>Get started with the BlackRock Bond Pyramid</h3>
						<p>
							Use the BlackRock Bond Pyramid to build a bond allocation that is tailored to your overall portfolio.
						</p>
					</div>
				</section>

				<section className="row body-section">
					<div className="col-6 offset">
						<div className="stack-landing">
							
							<div className="pink">
								<section >
									<div className="stack-landing-col" style={{width:incomeWidth + '%'}}>
										
											<div>{incomeAllocation}%</div>
											<div className="ticker">{incomeValue.value}</div>
									
										
									</div>
								</section>
							</div>
							
							<div className="yellow">
								<section>
									<div className="stack-landing-col" style={{width:capitalWidth + '%'}}> 
									
									<div>{capitalAllocation}%</div>
									<div className="ticker">{capitalValue.value}</div>
										
									</div>
								</section>
																		
							</div>
							<div className="orange">
								<section>
									<div className="stack-landing-col" style={{width:equityWidth + '%'}}>
									
									<div>{equityAllocation}%</div>
									<div className="ticker">{equityValue.value}</div>
										
									</div>
								</section>
																												
							</div>
						</div>
						<div className="legend">
							<div className="legend-item">
								<div className="legend-glyph pink"></div>
								<div>Income</div>
							</div>
							
							<div className="legend-item">
								<div className="legend-glyph yellow"></div>
								<div>Capital preservation</div>
							</div>
							<div className="legend-item">
								<div className="legend-glyph orange"></div>
								<div>Equity diversification</div>
							</div>
						</div>
						<ResultsTable 
							resultsData={resultsData} 
						/>
					</div>
					<div className="col-6">
						<div className="steps">Step 1: Select your overall asset allocation</div>
						
				

						<div className="slider-container">
						
						<ReactSlider
                                                value={sliderValue}
                                                className="toggle-slider"
                                                min={0}
                                                max={2}
                                                marks
                                                withTracks={true}                                         
                                                markClassName="slider-mark"
                                                step={1}
                                                thumbClassName="slider-thumb"
                                                trackClassName="slider-track"
												
                                                onChange={(newValue) => {
                                                    setSliderValue(newValue);
													if (newValue == 1) {
														setAllocation('M');
														tealiumTrack('bond-pyramid:button-selected:moderate','link')
													} else if (newValue == 2) {
														setAllocation('A');
														tealiumTrack('bond-pyramid:button-selected:aggressive','link')
													} else {
														setAllocation('C');
														tealiumTrack('bond-pyramid:button-selected:conservative','link')
													}
                                                }}
                                            />
                                            <div className="gutter">
                                                <span className={classnames({ active: sliderValue === 0 })} onClick={() => { setSliderValue(0); setAllocation('C'); tealiumTrack('bond-pyramid:button-selected:conservative','link')  } }>Conservative</span>
												<span className={classnames({ active: sliderValue === 1 })} onClick={() => { setSliderValue(1); setAllocation('M'); tealiumTrack('bond-pyramid:button-selected:moderate','link')  } }><span className="offset-16">Moderate</span></span>
                                                <span className={classnames({ active: sliderValue === 2 })} onClick={() => { setSliderValue(2); setAllocation('A'); tealiumTrack('bond-pyramid:button-selected:aggressive','link') } }>Aggressive</span>
                                            </div>

						</div>

					

						<div className="steps">Step 2: Choose Taxable or Municipal</div>
						<ButtonGroup size="lg" className="horizontal-button btnGroup">
							<Button  id="btn1" className="custom-btn" active={taxMuniciple === 'tax'} value="tax" onClick={() => {setTaxMuniciple('tax');tealiumTrack('bond-pyramid:button-selected:tax','link') }} >Taxable</Button>
							<Button  className="custom-btn"  active={taxMuniciple === 'municipal'} value="municipal" onClick={() => {setTaxMuniciple('municipal');tealiumTrack('bond-pyramid:button-selected:municipal','link') }}  >Municipal</Button>
						</ButtonGroup>

						<div className="steps">Step 3: Adjust funds as needed</div>
						<div>
							<FundSelector text="Income" value={incomeValue} 
								options={incomeOptions.map((cur) => arrFunds[cur])}
								onChange={value => {
									setIncomeValue(value);
									tealiumTrack('bond-pyramid:dropdown:income','link')
								}}
							/>
						</div>
						
						<div>
							<FundSelector text="Capital preservation" value={capitalValue} 
								options={capitalOptions.map((cur) => arrFunds[cur])}
								onChange={value => {
									setCapitalValue(value);
									tealiumTrack('bond-pyramid:dropdown:capital','link')
								}}
							/>
						</div>
						<div>
								<FundSelector text="Equity diversification" value={equityValue} 
									options={equityOptions.map((cur) => arrFunds[cur])}
									onChange={value => {
										setEquityValue(value);
										tealiumTrack('bond-pyramid:dropdown:value','link')
									}}
								/>
						</div>

						<div className="links">

					
							
							{tealiumLink('https://' +process.env.REACT_APP_BR_URL+ '/us/financial-professionals/tools/360-evaluator-tool/portfolio-editor/edit?holdings='+encodeURIComponent(stats.uri360),'Run analysis','icon fa fa-angle-right','')}

							{tealiumLink('https://' +process.env.REACT_APP_BR_URL+'/us/financial-professionals/literature/investor-guide/blackrock-bond-pyramid.pdf','Download guide','icon fa fa-download','inv')}

					


						</div>
					</div>
					<div className="vm">
					<p><a className="moreinfo" onClick={() => setMethodologyModal(true)}>View methodology.</a> For important additional information, <a className="moreinfo" href="#bp-disclosures">click here</a>.</p>              
								
								<p>*Source: Morningstar Direct as of {modDateFormat}. Yield shown is 12-month yield. Average effective duration, standard deviation and correlation are calculated for each fund and averaged based on allocation assigned within Bond Pyramid.</p>
								
								
								<p className="performanceText"><i>Performance data represents past performance and does not guarantee future results. Investment return and principal value will 
									fluctuate with market conditions and may be lower or higher when you sell your shares. Current performance may differ from the performance 
									shown and may be found by visiting <a className="moreinfo" href="https://www.ishares.com" target="_blank">www.ishares.com</a> and <a className="moreinfo" href="https://www.blackrock.com" target="_blank">www.blackrock.com</a>.</i></p>




									<p>For most recent month-end performance and standardized performance, visit the respective fund's product page:</p>

									<p>
										
									{tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/227615/?referrer=tickerSearch','BlackRock Income Fund')},&nbsp;

									{tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/227660/?referrer=tickerSearch','BlackRock Strategic Income Opportunities Fund')},&nbsp;

									{tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/227777/','BlackRock Total Return Fund')},&nbsp;

									{tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/264615/?referrer=tickerSearch','iShares Core Total USD Bond Market ETF')},&nbsp;

									{tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/244051/','iShares Core 1-5 Year USD Bond ETF')},&nbsp;

									{tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/239458/','iShares Core U.S. Aggregate Bond ETF')},&nbsp;

									{tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/227557/?referrer=tickerSearch','BlackRock High Yield Bond Fund')}, &nbsp;

									{tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/227598/','BlackRock Low Duration Bond Fund')},&nbsp;

									{tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/291299/?referrer=tickerSearch','iShares Broad USD High Yield Corporate Bond ETF')},&nbsp;

									{tealiumLinkFooter('BlackRock High Yield Municipal Fund','https://www.blackrock.com/us/financial-professionals/products/227560/')},&nbsp;
										
									{tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/227581/?referrer=tickerSearch','BlackRock Strategic Municipal Opportunities Fund')},&nbsp;

                                    {tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/239766/','iShares National Muni Bond ETF')},&nbsp;

                                    {tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/239772/','iShares Short-Term National Muni Bond ETF')},&nbsp;

                                    and {tealiumLinkFooter('https://www.blackrock.com/us/financial-professionals/products/227622/?referrer=tickerSearch','BlackRock National Municipal Fund')}.					
									
							

									</p>


									</div>


				</section>
			</div>
			

			
			<Modal
						size="lg"
						show={methodologyModal}
						onHide={() => setMethodologyModal(false)}
						dialogClassName="modal-90w"
						aria-labelledby="example-modal-sizes-title-lg">	
			
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-lg">
								Methodology
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
					
                        
                            <p>The “Bond Pyramid” experience (the “tool”) is designed to help investors learn how BlackRock actively managed bond mutual funds and iShares bond ETFs can work together in a portfolio to help clients achieve their financial goals. BlackRock mapped relevant Morningstar categories to the Bond Pyramid goals (income, capital preservation and equity diversification) based on the category’s historical characteristics and role in a portfolio.  BlackRock actively managed mutual funds and iShares ETFs were selected that have greater than $1b in assets under management and are the lowest cost option (based on net expense ratio) by vehicle, Morningstar category and Bond Pyramid goal. For flexible municipal bond funds such as the BlackRock Strategic Municipal Opportunities Fund, BlackRock assigns the funds to the Bond Pyramid’s capital preservation goal due the funds’ historical characteristics, which tend to more closely align to this goal.</p>



                            <p>The tool and products shown are not customized for any particular portfolio or investment circumstance. BlackRock, iShares and other third-party firms may consider other products that also relate to the outcomes shown. The outcomes shown are for illustrative purposes only and do not represent all possible investor outcomes. The funds shown are intended to illustrate possible investment ideas to consider. This information should not be relied upon as research, investment advice, or a recommendation regarding any products, strategies, or any security in particular. Any fund selection is not tailored to the investment objectives or needs of any particular investor. Investors should consult with their financial professionals prior to making an investment decision.</p>

                            <p>Please select “View all funds” to view and consider all BlackRock funds and iShares ETFs.</p>

                            <p>As of {modDateFormatTwo}. BlackRock funds and iShares ETFs launched after June 30, 2021 are not displayed in the tool. BlackRock and iShares product selections are reviewed quarterly to ensure the mutual funds and ETFs included in the tool meet the defined criteria defined. All other data is updated quarterly.</p>
                        </Modal.Body>
					</Modal>


			<Footer />

		

		</div>
	);
}
